import React, { useContext } from 'react';
import { GlobalContext } from '../../../contexts/states/GlobalState';

export const DesktopHeader = () => {
  const { admin } = useContext(GlobalContext);

  return (
    <div className='header-dash'>
      <div className='username'>
        <p>{admin.username}</p>
      </div>
      <div className='avatar'>
        <i className='fas fa-user'></i>
      </div>
    </div>
  );
};
